<template>
  <div class='securityCheck'>
    <div class="kv-box">
      <img class="kv" src="@/assets/serve/security/kv.png" alt="">
      <img src="@/assets/serve/security/tittle.png" alt="" class="title-image">
    </div>
    <img src="@/assets/serve/security/content.png" alt="" class="content">
  </div>
</template>

<script>
export default {
  name: 'SecurityCheck',
  components:{ 
    
  },
  data() {
    return {
      
    }
  },
  computed:{ },
  watch:{ },
  created() {
      
  },
  mounted() {
      
  },
  methods: {
      
  }
}
</script>
<style lang='less' scoped>
.securityCheck {
  width: 100%;
  .kv-box {
    width: 100%;
    max-width: 1920px;
    position: relative;
    margin: 0 auto;
    .kv {
      width: 100%;
      vertical-align: middle;
    }
    .title-image {
      width: 744.5px;
      height: 184px;
      position: absolute;
      top: 112.5px;
      left: 50%;
      margin-left: -372.25px;
    }
  }
  .content {
    width: 100%;
    max-width: 1920px;
    margin: 0 auto;
    vertical-align: middle;
  }
}
</style>